import React from 'react';
import { connect } from "react-redux";
import { Container, Row, Col, Table, Button } from 'react-bootstrap'
import PageBanner from '../common/page/PageBanner'
import Alert from '../common/modal/Alert';
import Paginator from '../common/page/Paginator'
import {getPaginatorHelper} from '../common/page/PaginatorHelper'
import Loading from '../common/modal/Loading';
import configData from "../../config/config.json";
import axios from "axios";
import { saveAs } from 'file-saver';

import {updateUserListFilters } from '../../redux/actions/userManagerActions';
import { setSelectedTenantAdminType, UserListTenantAdminKey  } from "../../redux/actions/tenantAdminActions";
import { LOADING_STATUES, ALERT_TYPES } from "../constants/constants";

const componentName = UserListTenantAdminKey;

export const UserListTenantAdminComponetName = "UserListTenantAdminComponetName";

const mapStateToProps = state => {

	return {
		sideNavigationOpen: state.sideNavigationReducer,
		paginationPage: state.usersPaginationTenantAdminReducer,
		userListFilters: state.userListFiltersReducer,
		role: state.currentUserReducer.role 
	};
}

const mapDispatchToProps = (dispatch) => {
	return {
		updateUserListFilters: (filters) => dispatch(updateUserListFilters(filters)),
		userListAccountFilter: (accountId, accountName) => dispatch({ type: 'SET_USER_LIST_ACCOUNT_FILTER', accountFilter: {accountId, accountName} }),
		alertListUserFilter: (userId, userName) => dispatch({ type: 'SET_ALERT_LIST_USER_FILTER', userFilter: {userId, userName} }),
		setSelectedTenantAdminType: () => dispatch(setSelectedTenantAdminType(componentName))
	}
}

class UserList extends React.Component {

	state = {
		filteredList: [],
		selectedId: 0,
		selectedUsername: '',
		statusType: this.props.userListFilters.statusType ? this.props.userListFilters.statusType : 'ALL',
		filterText: this.props.userListFilters.filterText ? this.props.userListFilters.filterText : '',
		status: '',
		showAlert: false,
		alertMessage: "",
		alertType: ALERT_TYPES.OK,
		filteringKey: 0 /*Is incremeted to re-render/mount the Paginator component */
	}

	showLoading = () => {
		if (this.state.status === "") {
			this.setState({
				status: LOADING_STATUES.LOADING
			})
			return true;
		}
		return false;
	}

	handleTextFilter = (filterText) => {
		this.setState({ filterText: filterText, filteringKey: this.state.filteringKey + 1  },  function() { this.handleFilter() } )
	}	

	handleTextFilterReset = () => {
		this.setState({ filterText: '', filteringKey: this.state.filteringKey + 1  }, function () { this.handleFilter() })
	}

	handleSelectFilter = (filterSelected) => {
		this.setState({ statusType: filterSelected }, function () { this.handleFilter() })
	}

	handleFilter = () => {
		if (this.showLoading() !== true) {
			return;
		}

		let filters = {filterText: this.state.filterText, statusType: this.state.statusType, accountId: this.state.accountId };
		axios.post(configData.LANDNOTIFICATION_SERVER_URL + "tenantAdmin/users", filters, { withCredentials: true })
		.then((response) => {
			this.setState({filteredList: response.data.content.users, status: '' })
			this.props.updateUserListFilters(filters);
		}, (error) => {
			this.setState({ status: '' }, this.showWarning(error.response.data.message));
		});
	}


	exportData = (event) => {
		event.preventDefault();
		if (this.showLoading() === true) {
			axios.post(configData.LANDNOTIFICATION_SERVER_URL + "tenantAdmin/userExport", { filterText: this.state.filterText, statusType: this.state.statusType }, { responseType: 'arraybuffer', withCredentials: true })
				.then((response) => {
					let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
					saveAs(blob, 'users.xlsx');
					this.setState({ status: '' })
				}, (error) => {
					this.setState({ status: '' }, this.showAlert(error.response.data.message));
				});	
		}
	}

	showAlert = (alertMessage) => {
		this.setState({
		  showAlert: true,
		  alertMessage
		})
	  }

	showWarning = (alertMessage) => {
		this.setState({
		  alertType: ALERT_TYPES.WARNING,
		  showAlert: true,
		  alertMessage
		})
	}
	
	handleRowView = (event) => {
		event.preventDefault();
		this.props.history.push('/tenantAdmin/users/' + event.target.closest("tr").id);
	}

	hideAlert = () => {
		this.setState({
			showAlert: false,
			alertMessage: "",
			alertType: ALERT_TYPES.OK
		}, this.props.history.push('/tenantAdmin/users'))
	}

	handleRedirectToAlerts = (event) => {
		event.preventDefault();
		let selectedId = event.target.closest("tr").id;
		let selectedUserName = event.target.closest("tr").getAttribute("name");
	
		this.setState({ selectedId, selectedUserName });
	
		this.props.history.push('/tenantAdmin/alerts');
	
		this.props.alertListUserFilter(selectedId, selectedUserName);
	  }

	componentDidMount() {
		this.props.setSelectedTenantAdminType();
		this.handleFilter();
	}

	render() {

		let formTemplateMarginLeft = 60
		if (this.props.sideNavigationOpen) {
		  formTemplateMarginLeft = 270
		}
		
		let buttons = [{ label: 'Export', onClickAction: this.exportData, className: 'btn btn-secondary' }]

		const selectFilterProps = {
			selectFilter: this.handleSelectFilter,
			options: [{code: "ALL", description: "All Users"}, {code: "A", description: "Active Users Only"}, {code: "I", description: "Inactive Users Only"}, {code: "P", description: "Pending Users Only"}],
			selected: this.state.statusType
		}

		const textFilterProps = {
			textFilter: this.handleTextFilter,
			textFilterReset: this.handleTextFilterReset,
			filterText: this.state.filterText
		}

		const numberOfVisibleRecords = 10;
		let numberOfPages = Math.ceil ( this.state.filteredList.length / numberOfVisibleRecords );
		let paginationHelper = getPaginatorHelper(this.props.paginationPage, this.state.filteredList, numberOfVisibleRecords);

		return (
		
			<div style={{ marginTop: 4, marginLeft: formTemplateMarginLeft, marginRight: 20, paddingBottom: 4, borderTop: '1px solid lightGray', boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.55), 0 6px 20px 0 rgba(0, 0, 0, 0.54)"  }}>
				{ 	
					(this.props.role === 'FOREVER' || this.props.role === 'TRIMIN' || this.props.role === 'TENANT') &&
					<PageBanner pageHeading='Users' textFilterProps={textFilterProps} selectFilterProps={selectFilterProps} buttons={buttons} />
				}
				{ 	
					(this.props.role !== 'FOREVER' && this.props.role !== 'TRIMIN' && this.props.role !== 'TENANT') &&
					<PageBanner pageHeading='Users' textFilterProps={textFilterProps} selectFilterProps={selectFilterProps} buttons={buttons} />
				}
				<Container fluid="true">
					<Row>
						<Col style={{ paddingLeft: 0, paddingRight: 0, paddingBottom: 0, marginTop: 20, marginLeft: 20,  marginRight: 20, border: '3px solid darkGray', borderRadius: '5px' }}>
							<Table striped hover size="sm" >
								<thead>
									<tr>
										<th style={{width:'20%'}} scope="col">Username</th>
										<th style={{width:'25%'}} scope="col">Name</th>
										<th style={{width:'10%'}} scope="col">User Type</th>
										<th style={{width:'20%'}} scope="col"></th>
									</tr>
								</thead>

								<tbody>
									{
										paginationHelper.currentPageRecordList.map((userResult) => {
											let inactiveBadge = '';
											if ( userResult.status === 'I') {
												inactiveBadge = "inactive";
											} else if ( userResult.status === 'P') {
												inactiveBadge = "pending";
											} else if ( userResult.status === 'L') {
												inactiveBadge = "locked!"
											}

											return (
												<tr style={{ cursor: "pointer" }} id={userResult.id} name={userResult.username}  onClick={this.handleRowClick}>
													<td>{userResult.username}<span className='badge badge-light'>{inactiveBadge}</span></td>
													<td>{userResult.firstName} {userResult.lastName} </td>
													<td>{userResult.role}</td>
													<td style={{ float: 'right' }}>
														<Button variant="primary" size='sm' onClick={this.handleRowView}>View</Button>&nbsp;
														<Button variant="primary" size='sm' onClick={this.handleRedirectToAlerts}>Alerts ({userResult.alertCount})</Button>&nbsp;
													</td>
												</tr>
											)
										})
									}
								</tbody>
							</Table>
						</Col>
					</Row>
					<Row>&nbsp;</Row>
					<Row>
						<Col style={{marginLeft: 4}}>Displaying Results: {paginationHelper.currentPageStartingRecordNumber}-{paginationHelper.currentPageEndingRecordNumber} of {this.state.filteredList.length}</Col>
						<Col><Paginator style={{justifyContent: 'center'}} componentName={UserListTenantAdminComponetName} key={this.state.filteringKey} numberOfVisibleRecords={numberOfVisibleRecords} numberOfPages={numberOfPages} ></Paginator></Col>
					</Row>
				</Container>
				
				<Loading loadingIndicator={this.state.status === LOADING_STATUES.LOADING} />
				<Alert show={this.state.showAlert} hideAlert={this.hideAlert} message={this.state.alertMessage} type={this.state.alertType} />
			</div>

		)
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(UserList);